import * as CommonUtilities from "../../../../common/utils/CommonUtils.js";

/* One product you can put in a combo slot.

   ⚠ data-productid is read by handleSelectProductInComboList off currentTarget,
   so it stays on the button; inner markup is free.

   ⚠ A sold-out product is BOTH disabled and has its onClick removed. Keep both:
   the disabled attribute stops the click, the null handler stops anything that
   bypasses it. Its label says so in words rather than the old rotated ribbon,
   which overlapped the image at narrow widths.

   No placeholder graphic — a product with no photo gets a text-only row, same
   as the menu and the voucher list. */
export default function ProductComboListModalProduct(props) {

    let energyCount;
    if (props.data.energyCount !== 0 && props.data.energyCount !== "0" && props.data.energyCount !== "" && props.data.energyCount !== null) {
        energyCount = <span className="wo-pm__kj">{props.data.energyCount}kJ</span>
    } else {
        energyCount = <></>
    }

    const isSoldOut = !!props.data.isSoldOut;

    return (
        <button type="button"
            className={`wo-vprod${isSoldOut ? ' wo-vprod--out' : ''}`}
            data-productid={props.data.productId}
            onClick={isSoldOut ? null : props.handleSelectProductInComboList}
            disabled={isSoldOut}
        >
            {/* The slot is always rendered, even with no photo. In a list whose
                other rows have one, omitting it knocks the row out of
                alignment and reads as broken rather than as a choice. */}
            <span className={`wo-vprod__thumb${props.data.productImageURL ? '' : ' wo-vprod__thumb--empty'}`}>
                {props.data.productImageURL
                    ? <img src={props.data.productImageURL} alt="" loading="lazy" decoding="async" />
                    : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"
                           strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="3" y="4.5" width="18" height="15" rx="2.5" />
                        <circle cx="8.5" cy="10" r="1.6" />
                        <path d="M21 15.5l-4.6-4.3a1.6 1.6 0 0 0-2.2 0L5 19.5" />
                      </svg>}
            </span>

            <span className="wo-vprod__text">
                <span className="wo-vprod__nameRow">
                    <span className="wo-vprod__name">{props.data.productName}</span>
                    {energyCount}
                </span>
                {props.data.productDescription &&
                    <span className="wo-vprod__desc">{props.data.productDescription}</span>}
                {isSoldOut && <span className="wo-vprod__out">Sold out</span>}
            </span>

            {/* ⚠ Bulk pricing deliberately shows NO unit price here — the price
                depends on quantity, so a single figure would be wrong. The live
                code did this by having two near-identical branches where only
                the non-bulk one carried the price pill; the gate is the part
                that mattered and it is kept. Same rule as
                ProductComboChildModalPage and ProductDetailsModalPage. */}
            {CommonUtilities.StaticFields.PriceType !== 'bp8826' &&
                <span className="wo-vprod__price">
                    {CommonUtilities.StaticFields.CurrencySymbol}{props.data.priceInc.toFixed(2)}
                </span>}
        </button>
    )
}
